import React, { useEffect } from "react";
import "./ReflectionsInner.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  PostsDetailedData,
  mainPostData,
  paginationPostData,
} from "../../data/reflections";
import { reflectionsURL } from "../../helpers/constants";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import {
  facebookIcon,
  flower,
  instagramIcon,
  leftArrow,
  linkedInIcon,
  rightArrow,
  sun,
} from "../../source";
import { useWindowSize } from "react-use";
import { FacebookShareButton, LinkedinShareButton } from "react-share";

const ReflectionsInner = () => {
  const { width } = useWindowSize();
  const { slug } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const url = window.location.href;

  const postsData = mainPostData.find((data) => data.slug === slug);

  useEffect(() => {
    console.log("slug", slug);
    if (!postsData) {
      return navigate(reflectionsURL);
    }
  }, [pathname, navigate, slug, postsData?.slug]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (!postsData) {
    return null;
  }

  return (
    <>
      <section className="reflection_inner_sec1">
        <CommonBanner
          description={postsData?.bannerDesc}
          link1={reflectionsURL}
          linkText1="Reflections"
          linkText2={postsData?.name}
        />
        {/* <p>{postsData?.desc}</p> */}
      </section>

      <section className="reflection_inner_sec2" data-aos="fade-up">
        <div className="my_container">
          <div className="post_container">
            {/* {postsData?.paraContent.map((content, index) => ( */}
            <div
              className="post_data_wrapper"
              key={postsData?.id}
              data-aos="fade-up"
            >
              <h2 className="section_heading48">{postsData?.title}</h2>
              <p
                className="section_desc22"
                key={postsData?.id}
                dangerouslySetInnerHTML={{ __html: postsData?.description }}
              />
              {/* {content?.desc.map((item, i) => (
                ))} */}
              {postsData?.img && (
                <div className="img_wrapper" data-aos="fade-up">
                  <img src={sun} alt="sun" className="sun_img" />
                  <img src={flower} alt="sun" className="flower_img" />
                  <img
                    src={
                      width <= 767 && postsData.mbImg
                        ? postsData.mbImg
                        : postsData.img
                    }
                    alt={postsData.alt}
                    className="post_inner_img"
                  />
                </div>
              )}
            </div>
            <p className="section_desc22 contributer" data-aos="fade-up">
              <b>Contributer:</b> Marouf Tirad
            </p>
          </div>

          <div className="social_container" data-aos="fade-up">
            <p className="section_desc20">Share</p>
            <span className="social_link">
              <FacebookShareButton url={url}>
                <img
                  src={facebookIcon}
                  alt="facebook"
                  className="fb_icon social_icon"
                />
              </FacebookShareButton>
            </span>
            {/* <a
              className="social_link"
              href={postsData?.instaLink}
              rel="noreferrer"
              target="_blank"
            >
              <img
                src={instagramIcon}
                alt="instagram"
                className="social_icon"
              />
            </a> */}
            <span className="social_link">
              <LinkedinShareButton url={url}>
                <img
                  src={linkedInIcon}
                  alt="linkedIn"
                  className="social_icon"
                />
              </LinkedinShareButton>
            </span>
          </div>

          {/* <div className="post_pagination_container" data-aos="fade-up">
            <div className="btn_wrapper">
              <div className="btns">
                <img
                  src={leftArrow}
                  alt="left arrow"
                  className="left_arrow_img"
                />
                <p className="btn_text">PREVIOUS BLOG</p>
              </div>
              <div className="btns">
                <p className="btn_text">NEXT BLOG</p>
                <img
                  src={rightArrow}
                  alt="right arrow"
                  className="right_arrow_img"
                />
              </div>
            </div>

            <div className="pagi_section">
              <div className="pagi_post_container">
                {paginationPostData.map((item, i) => (
                  <div className="post_box" key={i}>
                    <img
                      src={item.img}
                      alt={item.alt}
                      className={`pagi_img ${
                        i % 2 === 0 ? "order-1" : "order-2"
                      }`}
                    />
                    <h2
                      className={`pagi_heading ${
                        i % 2 === 0 ? "order-2" : "order-1"
                      }`}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    ></h2>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default ReflectionsInner;
